import React from 'react';

import t from 'utils/translate';

import Text from 'admin/components/common/Text';
import { MODAL } from 'admin/constants/common';
import type { ModalManagerProvidedProps } from 'admin/components/common/ModalManager';
import { Modal } from 'admin/components/common/Modal';
import { isMatching, QUERY } from 'admin/components/common/Responsive';
import ChangePasswordForm from 'admin/components/common/ChangePasswordForm';

import css from '../ModalGeneral.scss';

type Props = ModalManagerProvidedProps<MODAL.CHANGE_USER_PASSWORD>;

const ChangeUserPasswordModal: React.FC<Props> = ({ open, close }) => {
	const isMobile = isMatching(QUERY.MOBILE);

	const renderTitle = () => (
		<Text
			size={isMobile ? Text.size.subheading : Text.size.subtitle}
			weight={Text.weight.semibold}
			compact
			text={t('profile.changePassModal.title')}
		/>
	);

	return (
		<Modal
			title={renderTitle()}
			open={open}
			destroyOnHidden
			width="864px"
			fullScreen={isMobile}
			className={css.modal}
		>
			<ChangePasswordForm onCancel={close} onSuccess={close} showCancelButton />
		</Modal>
	);
};

export default ChangeUserPasswordModal;
